import React from 'react';
import { ActiveDot } from 'components/Dropdown/Dropdown.styles';
import { Box, Button, HStack, Menu, MenuButton, MenuGroup, MenuItem, MenuList, Text } from '@chakra-ui/react';
import IconChevronDown from 'lib/components/Icons/IconChevronDown';
import IconChevronUp from 'lib/components/Icons/IconChevronUp';
import { groupBy } from 'lodash';

export const DropdownMenu = ({ label, handleChange, selectedItem, items }) => {
    const groupedItems = groupBy(items, 'group');

    return (
        <Menu gutter={0} matchWidth>
            {({ isOpen }) => (
                <>
                    <MenuButton
                        as={Button}
                        rightIcon={isOpen ? <IconChevronUp /> : <IconChevronDown />}
                        size="sm"
                        ml={3}
                        bg="black"
                        border="1px solid"
                        borderColor="transparent"
                        borderBottom="none"
                        _active={{
                            bg: 'grayDark',
                            borderColor: 'black',
                        }}
                        rounded={false}
                        data-testid={`${label}_dropdown`}>
                        <HStack gap={2}>
                            <Text casing="uppercase" fontWeight="normal" opacity={0.5} as="span">
                                {label}
                            </Text>
                            <Text casing="uppercase" as="span">
                                {selectedItem.text}
                            </Text>
                        </HStack>
                    </MenuButton>
                    <MenuList data-testid="park-select-menu-list" zIndex="dropdown" minWidth={2} shadow="none">
                        {Object.keys(groupedItems).map((groupName) => (
                            <MenuGroup title={groupName !== 'undefined' && groupName}>
                                {groupedItems[groupName].map((item) => (
                                    <MenuItem onClick={handleChange(item)} data-testid="dropdown-item">
                                        <Box py={0} pl={1} display="inherit">
                                            <ActiveDot isActive={selectedItem.text === item.text} />
                                        </Box>
                                        <Text casing="uppercase" as="span">
                                            {item.text}
                                        </Text>
                                    </MenuItem>
                                ))}
                            </MenuGroup>
                        ))}
                    </MenuList>
                </>
            )}
        </Menu>
    );
};
